import React, { useEffect, useState } from "react";
import { Table, Button } from "antd"; // Import Table and Button from Ant Design

function GroceryDetail({ allData }) {
  console.log(allData)
  const [data, setData] = useState([]);
  const [showAllItems, setShowAllItems] = useState(false); // State to manage visibility of items
  const [showAllSales, setShowAllSales] = useState(false); // State to manage visibility of sales

  useEffect(() => {
    setData(allData);
  }, [allData]);

  // Define columns for the items table
  const itemsColumns = [
    {
      title: "Name",
      dataIndex: "item",
      key: "item",
    },
    {
      title: "Sale Ratio",
      dataIndex: "saleRatio",
      key: "saleRatio",
    },
    {
      title: "Sale Ratio Value",
      dataIndex: "saleRatioValue",
      key: "saleRatioValue",
    },
    {
      title: "Gross Profit",
      dataIndex: "grossProfit",
      key: "grossProfit",
    },
    {
      title: "Created At",
      dataIndex: "created",
      key: "created",
    },
    // Add other columns as needed
  ];

  // Define columns for the sales table
  const salesColumns = [
    {
      title: "Remark",
      dataIndex: "remark",
      key: "remark",
    },
    {
      title: "Credit Sale",
      dataIndex: "creditSale",
      key: "creditSale",
    },
    {
      title: "Cash Sale",
      dataIndex: "cashSale",
      key: "cashSale",
    },
    {
      title: "Year",
      dataIndex: "year",
      key: "year",
    },
    {
      title: "Created At",
      dataIndex: "created",
      key: "created",
    },
    // Add other columns as needed
  ];

  return (
    <div className="container-fluid">
      <div className="row">
        {data && data.length > 0 ? (
          data.map((item, index) => (
            <div key={index} className="col-12 mb-4">
              <h5 className="mb-2">{item?.shop?.name}</h5>
              <div className="card shadow-sm">
                <div className="card-body">
                  {/* Render Items section if there are items */}
                  {item.items && item.items.length > 0 && (
                    <div className="table-responsive mb-3">
                      <h6 className="text-danger">Items</h6>
                      <Table
                        dataSource={item?.items}
                        columns={itemsColumns}
                        pagination={false}
                        rowKey={(record) => record.id}
                      />
                      {/* {item.items.length > 3 && (
                        <Button
                          onClick={() => setShowAllItems(!showAllItems)}
                          className="mt-2"
                        block>
                          {showAllItems ? 'Show Less' : 'View All'}
                        </Button>
                      )} */}
                    </div>
                  )}

                  {/* Render Sales section if there are sales */}
                  {item.sales && item.sales.length > 0 && (
                    <div className="table-responsive mb-3">
                      <h6 className="text-danger">Sales</h6>
                      <Table
                        dataSource={item?.sales}
                        columns={salesColumns}
                        pagination={false}
                        rowKey={(record) => record.id}
                      />
                      {/* {item.sales.length > 3 && (
                        <Button
                          onClick={() => setShowAllSales(!showAllSales)}
                          className="mt-2"
                       block >
                          {showAllSales ? 'Show Less' : 'View All'}
                        </Button>
                      )} */}
                    </div>
                  )}
                </div>
              </div>
            </div>
          ))
        ) : (
          <div className="col-12">
            <div className="card text-center">
              <div className="card-body">
                <p>No data available</p>
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
}

export default GroceryDetail;
